import { Authority } from '@/shared/security/authority';
/* tslint:disable */
// prettier-ignore

// prettier-ignore
const CrawfordProduct = () => import('@/entities/crawford-product/crawford-product.vue');
// prettier-ignore
const CrawfordProductUpdate = () => import('@/entities/crawford-product/crawford-product-update.vue');
// prettier-ignore
const CrawfordProductDetails = () => import('@/entities/crawford-product/crawford-product-details.vue');
// prettier-ignore
const Client = () => import('@/entities/client/client.vue');
// prettier-ignore
const ClientUpdate = () => import('@/entities/client/client-update.vue');
// prettier-ignore
const ClientDetails = () => import('@/entities/client/client-details.vue');
// prettier-ignore
const Integration = () => import('@/entities/integration/integration.vue');
// prettier-ignore
const IntegrationUpdate = () => import('@/entities/integration/integration-update.vue');
// prettier-ignore
const IntegrationDetails = () => import('@/entities/integration/integration-details.vue');
// prettier-ignore
const Importer = () => import('@/entities/importer/importer.vue');
// prettier-ignore
const ImporterUpdate = () => import('@/entities/importer/importer-update.vue');
// prettier-ignore
const ImporterDetails = () => import('@/entities/importer/importer-details.vue');
// prettier-ignore
const ClientUser = () => import('@/entities/client-user/client-user.vue');
// prettier-ignore
const ClientUserUpdate = () => import('@/entities/client-user/client-user-update.vue');
// prettier-ignore
const ClientUserDetails = () => import('@/entities/client-user/client-user-details.vue');
// prettier-ignore
const ClientUserIntegration = () => import('@/entities/client-user-integration/client-user-integration.vue');
// prettier-ignore
const ClientUserIntegrationUpdate = () => import('@/entities/client-user-integration/client-user-integration-update.vue');
// prettier-ignore
const ClientUserIntegrationDetails = () => import('@/entities/client-user-integration/client-user-integration-details.vue');
// prettier-ignore
const ClientProductHeaderMap = () => import('@/entities/client-product-header-map/client-product-header-map.vue');
// prettier-ignore
const ClientProductHeaderMapUpdate = () => import('@/entities/client-product-header-map/client-product-header-map-update.vue');
// prettier-ignore
const ClientProductHeaderMapDetails = () => import('@/entities/client-product-header-map/client-product-header-map-details.vue');
// prettier-ignore
const ClientProductMatch = () => import('@/entities/client-product-match/client-product-match.vue');
// prettier-ignore
const ClientProductMatchUpdate = () => import('@/entities/client-product-match/client-product-match-update.vue');
// prettier-ignore
const ClientProductMatchDetails = () => import('@/entities/client-product-match/client-product-match-details.vue');
// prettier-ignore
const ClientGeneratedProduct = () => import('@/entities/client-generated-product/client-generated-product.vue');
// prettier-ignore
const ClientGeneratedProductUpdate = () => import('@/entities/client-generated-product/client-generated-product-update.vue');
// prettier-ignore
const ClientGeneratedProductDetails = () => import('@/entities/client-generated-product/client-generated-product-details.vue');
// prettier-ignore
const ImporterConfig = () => import('@/entities/importer-config/importer-config.vue');
// prettier-ignore
const ImporterConfigUpdate = () => import('@/entities/importer-config/importer-config-update.vue');
// prettier-ignore
const ImporterConfigDetails = () => import('@/entities/importer-config/importer-config-details.vue');
// prettier-ignore
const ClientImporter = () => import('@/entities/client-importer/client-importer.vue');
// prettier-ignore
const ClientImporterUpdate = () => import('@/entities/client-importer/client-importer-update.vue');
// prettier-ignore
const ClientImporterDetails = () => import('@/entities/client-importer/client-importer-details.vue');
// prettier-ignore
const ClientImporterRequest = () => import('@/entities/client-importer-request/client-importer-request.vue');
// prettier-ignore
const ClientImporterRequestUpdate = () => import('@/entities/client-importer-request/client-importer-request-update.vue');
// prettier-ignore
const ClientImporterRequestDetails = () => import('@/entities/client-importer-request/client-importer-request-details.vue');
// prettier-ignore
const ClientImporterRequestFile = () => import('@/entities/client-importer-request-file/client-importer-request-file.vue');
// prettier-ignore
const ClientImporterRequestFileUpdate = () => import('@/entities/client-importer-request-file/client-importer-request-file-update.vue');
// prettier-ignore
const ClientImporterRequestFileDetails = () => import('@/entities/client-importer-request-file/client-importer-request-file-details.vue');
// prettier-ignore
const OrdersImported = () => import('@/entities/orders-imported/orders-imported.vue');
// prettier-ignore
const OrdersImportedUpdate = () => import('@/entities/orders-imported/orders-imported-update.vue');
// prettier-ignore
const OrdersImportedDetails = () => import('@/entities/orders-imported/orders-imported-details.vue');
// prettier-ignore
const OrdersExported = () => import('@/entities/orders-exported/orders-exported.vue');
// prettier-ignore
const OrdersExportedUpdate = () => import('@/entities/orders-exported/orders-exported-update.vue');
// prettier-ignore
const OrdersExportedDetails = () => import('@/entities/orders-exported/orders-exported-details.vue');
// jhipster-needle-add-entity-to-router-import - JHipster will import entities to the router here

export default [
  {
    path: '/crawford-product',
    name: 'CrawfordProduct',
    component: CrawfordProduct,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/crawford-product/new',
    name: 'CrawfordProductCreate',
    component: CrawfordProductUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/crawford-product/:crawfordProductId/edit',
    name: 'CrawfordProductEdit',
    component: CrawfordProductUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/crawford-product/:crawfordProductId/view',
    name: 'CrawfordProductView',
    component: CrawfordProductDetails,
    meta: { authorities: [Authority.USER] },
  },

  {
    path: '/client',
    name: 'Client',
    component: Client,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/client/new',
    name: 'ClientCreate',
    component: ClientUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/client/:clientId/edit',
    name: 'ClientEdit',
    component: ClientUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/client/:clientId/view',
    name: 'ClientView',
    component: ClientDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/integration',
    name: 'Integration',
    component: Integration,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/integration/new',
    name: 'IntegrationCreate',
    component: IntegrationUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/integration/:integrationId/edit',
    name: 'IntegrationEdit',
    component: IntegrationUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/integration/:integrationId/view',
    name: 'IntegrationView',
    component: IntegrationDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/importer',
    name: 'Importer',
    component: Importer,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/importer/new',
    name: 'ImporterCreate',
    component: ImporterUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/importer/:importerId/edit',
    name: 'ImporterEdit',
    component: ImporterUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/importer/:importerId/view',
    name: 'ImporterView',
    component: ImporterDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/crawford-product',
    name: 'CrawfordProduct',
    component: CrawfordProduct,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/crawford-product/new',
    name: 'CrawfordProductCreate',
    component: CrawfordProductUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/crawford-product/:crawfordProductId/edit',
    name: 'CrawfordProductEdit',
    component: CrawfordProductUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/crawford-product/:crawfordProductId/view',
    name: 'CrawfordProductView',
    component: CrawfordProductDetails,
    meta: { authorities: [Authority.USER] },
  },

  {
    path: '/client-user',
    name: 'ClientUser',
    component: ClientUser,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/client-user/new',
    name: 'ClientUserCreate',
    component: ClientUserUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/client-user/:clientUserId/edit',
    name: 'ClientUserEdit',
    component: ClientUserUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/client-user/:clientUserId/view',
    name: 'ClientUserView',
    component: ClientUserDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/client-user-integration',
    name: 'ClientUserIntegration',
    component: ClientUserIntegration,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/client-user-integration/new',
    name: 'ClientUserIntegrationCreate',
    component: ClientUserIntegrationUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/client-user-integration/:clientUserIntegrationId/edit',
    name: 'ClientUserIntegrationEdit',
    component: ClientUserIntegrationUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/client-user-integration/:clientUserIntegrationId/view',
    name: 'ClientUserIntegrationView',
    component: ClientUserIntegrationDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/client-product-header-map',
    name: 'ClientProductHeaderMap',
    component: ClientProductHeaderMap,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/client-product-header-map/new',
    name: 'ClientProductHeaderMapCreate',
    component: ClientProductHeaderMapUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/client-product-header-map/:clientProductHeaderMapId/edit',
    name: 'ClientProductHeaderMapEdit',
    component: ClientProductHeaderMapUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/client-product-header-map/:clientProductHeaderMapId/view',
    name: 'ClientProductHeaderMapView',
    component: ClientProductHeaderMapDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/client-product-match',
    name: 'ClientProductMatch',
    component: ClientProductMatch,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/client-product-match/new',
    name: 'ClientProductMatchCreate',
    component: ClientProductMatchUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/client-product-match/:clientProductMatchId/edit',
    name: 'ClientProductMatchEdit',
    component: ClientProductMatchUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/client-product-match/:clientProductMatchId/view',
    name: 'ClientProductMatchView',
    component: ClientProductMatchDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/client-generated-product',
    name: 'ClientGeneratedProduct',
    component: ClientGeneratedProduct,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/client-generated-product/new',
    name: 'ClientGeneratedProductCreate',
    component: ClientGeneratedProductUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/client-generated-product/:clientGeneratedProductId/edit',
    name: 'ClientGeneratedProductEdit',
    component: ClientGeneratedProductUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/client-generated-product/:clientGeneratedProductId/view',
    name: 'ClientGeneratedProductView',
    component: ClientGeneratedProductDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/importer-config',
    name: 'ImporterConfig',
    component: ImporterConfig,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/importer-config/new',
    name: 'ImporterConfigCreate',
    component: ImporterConfigUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/importer-config/:importerConfigId/edit',
    name: 'ImporterConfigEdit',
    component: ImporterConfigUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/importer-config/:importerConfigId/view',
    name: 'ImporterConfigView',
    component: ImporterConfigDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/client-importer',
    name: 'ClientImporter',
    component: ClientImporter,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/client-importer/new',
    name: 'ClientImporterCreate',
    component: ClientImporterUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/client-importer/:clientImporterId/edit',
    name: 'ClientImporterEdit',
    component: ClientImporterUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/client-importer/:clientImporterId/view',
    name: 'ClientImporterView',
    component: ClientImporterDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/client-importer-request',
    name: 'ClientImporterRequest',
    component: ClientImporterRequest,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/client-importer-request/new',
    name: 'ClientImporterRequestCreate',
    component: ClientImporterRequestUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/client-importer-request/:clientImporterRequestId/edit',
    name: 'ClientImporterRequestEdit',
    component: ClientImporterRequestUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/client-importer-request/:clientImporterRequestId/view',
    name: 'ClientImporterRequestView',
    component: ClientImporterRequestDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/client-importer-request-file',
    name: 'ClientImporterRequestFile',
    component: ClientImporterRequestFile,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/client-importer-request-file/new',
    name: 'ClientImporterRequestFileCreate',
    component: ClientImporterRequestFileUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/client-importer-request-file/:clientImporterRequestFileId/edit',
    name: 'ClientImporterRequestFileEdit',
    component: ClientImporterRequestFileUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/client-importer-request-file/:clientImporterRequestFileId/view',
    name: 'ClientImporterRequestFileView',
    component: ClientImporterRequestFileDetails,
    meta: { authorities: [Authority.USER] },
  },

  {
    path: '/orders-imported',
    name: 'OrdersImported',
    component: OrdersImported,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/orders-imported/new',
    name: 'OrdersImportedCreate',
    component: OrdersImportedUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/orders-imported/:ordersImportedId/edit',
    name: 'OrdersImportedEdit',
    component: OrdersImportedUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/orders-imported/:ordersImportedId/view',
    name: 'OrdersImportedView',
    component: OrdersImportedDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/orders-exported',
    name: 'OrdersExported',
    component: OrdersExported,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/orders-exported/new',
    name: 'OrdersExportedCreate',
    component: OrdersExportedUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/orders-exported/:ordersExportedId/edit',
    name: 'OrdersExportedEdit',
    component: OrdersExportedUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/orders-exported/:ordersExportedId/view',
    name: 'OrdersExportedView',
    component: OrdersExportedDetails,
    meta: { authorities: [Authority.USER] },
  },
  // jhipster-needle-add-entity-to-router - JHipster will add entities to the router here
];
